import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification, Drawer, Button, Space, Modal } from "antd";
import { FaEdit, FaEye, FaRegEnvelope, FaArrowsAltV, FaSortAlphaDown, FaSortAlphaUp, FaSortNumericDown, FaSortNumericUp } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Pagination from "@mui/material/Pagination";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import TobNavBar from "../DashBaord/Top_navbar";
import { Link, useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";


import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  LikeOutlined,
  DislikeOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  CalendarOutlined,
  CloseCircleOutlined,
  EyeOutlined
} from "@ant-design/icons";

import moment from "moment";
import { ASSETS_BASE_URL, COMPANY_LOGIN_URL, INVESTOR_LOGIN_URL } from "../../config/constants";
import SkeltonList from "../../components/SkeltonEffect/list";
import {list} from "../../controllers/yearly_meetings/yearlyMeetController";
import { getPageMore, statusInterestMessage } from "../../controllers/common";
import { sendMeetingCancelledMail } from "../../controllers/sendMail/mailcontroller";

import { FaPlusSquare } from "react-icons/fa";

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {

  const [popUpOpen, setPopUpOpen] = useState(false);
  const togglePopUp = () => {
    setPopUpOpen(!popUpOpen);
  };
  const handleCancel = () => {
    togglePopUp();
    // cancelReason();
  };

  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => {
    setFilterShow(!isFilterShow);
  } 

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(20);
  const [SKIP, setSkip] = useState(0);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [filter, setFilter] = useState({
    // from: "",
    // to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [totalmeetcount, settotalMeetcount] = useState("");

  const [sortByFirmname, setSortByFirmName] = useState("");
    const handleFirmNameSort = () => {
      setSortByInvestorName("");
      setSortByCompName("");
      setSortByFirmName((prevSort) => (prevSort === "Y" ? "N" : "Y"));
    };
  
    const [sortByInvestorname, setSortByInvestorName] = useState("");
    const handleInvestorNameSort = () => {
      setSortByFirmName("");
      setSortByCompName("");
      setSortByInvestorName((prevSort) => (prevSort === "Y" ? "N" : "Y"));
    };
  
    const [sortByCompname, setSortByCompName] = useState("");
    const handleCompNameSort = () => {
      setSortByFirmName("");
      setSortByInvestorName("");
      setSortByCompName((prevSort) => (prevSort === "Y" ? "N" : "Y"));
    };


  /*********************************************************
   *  This function is use to fetch investors list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: { year: selectedYear },
        ...(filter?{filter:filter}:null),
        select: {},
        // sort: {  meet_id: 1 },
        sort: { 
          ...(sortByFirmname && { investor_firm: sortByFirmname === "Y" ? 1 : -1 }),
          ...(sortByInvestorname && { investor_name: sortByInvestorname === "Y" ? 1 : -1 }),
          ...(sortByCompname && { company_name: sortByCompname === "Y" ? 1 : -1 }),
              },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 20,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
        } else {
          setListData([]);
        }
        const countOptions = {
          type: "count",
          condition: { year: selectedYear },
          ...(filter?{filter:filter}:null)
        };
        const count = await list(countOptions);
        settotalMeetcount(count?.result);
        setTotalPages(getPageMore(count?.result));
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  const handleYearChange = (event) => {
    const year = Number(event.target.value);
    setSelectedYear(year);
    setCurrentPage(1);
    setSkip(0);
  };


  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const handleUploadYearlyMeetings = async () => {
    navigate("/yearly-meetings-data/upload");
  };

  /*********************************************************
   *  This function is ued for handle filter input chnage
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      setSkip(0);
      setCurrentPage(1);
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        // 'to'        : form.get('to_date') || '',
        // 'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFiterDrawer();
      setSkip(0);
      setCurrentPage(1);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Chiratae Super Admin || Meetings List";
  }, [currentPage, sortByFirmname, sortByInvestorname, sortByCompname, popUpOpen, filter, selectedYear]);

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Yearly Meetings List"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="d-flex align-items-center justify-content-center">
                    <label style={{width: "150px"}}>Select Year</label>
                    <select
                      value={selectedYear}
                      onChange={handleYearChange}
                      className="form-control"
                    >
                      {/* <option value="">Select Year</option> */}
                      <option value={currentYear}>{currentYear}</option>
                      <option value={currentYear - 1}>{currentYear - 1}</option>
                      {/* <option value={currentYear - 2}>{currentYear - 2}</option> */}
                    </select>
                  </div>
                  <div className=''>
                    <Button
                      type="primary"
                      onClick={handleUploadYearlyMeetings}
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      <FaPlusSquare style={{ marginRight: "5px" }} />
                      Upload Yearly Meetings
                    </Button>
                  </div>
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                    <img
                      src={ASSETS_BASE_URL + "/images/Filter.svg"}
                      alt="filter"
                      className="user_iconses"
                    />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filters
                    </Link>
                  </div>
                </div>
              </div>
            </Box>
            {/* First Inventory */}
            <VendorList 
              //value={value} index={0}
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            { totalmeetcount ? (
                              <tr><th style={{color:"red", fontSize:"18px",fontWeight:"600"}} colSpan={2}>{`Total - ${totalmeetcount}`}</th></tr>
                            ):null} 
                            <tr>
                              <th style={{width:"8%"}}>Sr no.</th>
                              {/* <th>id</th> */}
                              <th>Investor's Firm {sortByFirmname === "Y" ? (
                                <FaSortAlphaDown
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleFirmNameSort()}
                                />
                              ) : (
                                <FaSortAlphaUp
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleFirmNameSort()}
                                />
                              )}</th>
                              <th>Investor {sortByInvestorname === "Y" ? (
                                <FaSortAlphaDown
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleInvestorNameSort()}
                                />
                              ) : (
                                <FaSortAlphaUp
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleInvestorNameSort()}
                                />
                              )}</th>
                              <th>Company {sortByCompname === "Y" ? (
                                <FaSortAlphaDown
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleCompNameSort()}
                                />
                              ) : (
                                <FaSortAlphaUp
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleCompNameSort()}
                                />
                              )}</th>
                              <th>Priority</th>
                              <th>Slot</th>
                              {/* <th>Time</th> */}
                              <th>Date</th>
                              <th>Status</th>
                              {/* <th>Actions</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{(currentPage - 1) * 20 + index + 1}</td>
                                    {/* <td className="admin_user_list_date"> {items?.meet_id} </td> */}
                                    {/* <td>{items?._id}</td> */}
                                    <td className="admin_user_list_date">
                                    {items?.investor_firm}
                                    </td>
                                    <td className="admin_user_list_date">
                                      {items?.investor_name}
                                    </td>
                                    <td className="admin_user_list_date">
                                      {" "}
                                      {items?.company_name}
                                    </td>
                                    <td className="admin_user_list_date">
                                      {(items?.priority === 1 || items?.priority === '1')?'First':'Second'}
                                    </td>
                                    <td className="admin_user_list_date">
                                      {items?.time_slot}
                                    </td>
                                    {/* <td id="meetdate"
                                      className="admin_user_list_date">
                                        {items?.time_from} {" - "} {items?.time_to}
                                    </td> */}
                                    <td className="admin_user_list_date">
                                      {items?.date}
                                    </td>
                                    <td className="admin_user_list_date">
                                      <span>{items?.status}</span>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={12} /> : <tr> 
                                <td colspan="5" className="img-center" ><p>No data to show</p></td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                            page={currentPage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Filter */}
      <Drawer
        title="Yearly Meetings Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="investor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='investor_firm' selected={filter?.filter_by ==='investor_firm'?true:false}>Investor Firm</option>
                  <option value='investor_name' selected={filter?.filter_by ==='investor_name'?true:false}>Investor Name</option>
                  <option value='company_name' selected={filter?.filter_by ==='company_name'?true:false}>Company Name</option>
                  <option value='time_from' selected={filter?.filter_by ==='time_from'?true:false}>Start Time</option>
                  <option value='status' selected={filter?.filter_by ==='status'?true:false}>Status</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="investor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                  // onChange={handleFilterChnage} 
                  // value={filter?.search}             
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
